<template>
    <div>
        <div class="search-box">
            <p>获奖类型：</p>
            <a-input class="input-box" v-model="searchFrom.winningType" />
            <p>获奖等级：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.winningGrade" :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in hjdjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>获奖成果名称：</p>
            <a-input class="input-box" v-model="searchFrom.winningName" />
            <p>证书编码：</p>
            <a-input class="input-box" v-model="searchFrom.winningNo" />
            <p>完成人：</p>
            <a-input class="input-box" v-model="searchFrom.winner" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <!-- <a-button type="primary" icon="download" class="right-btn" >导出Excel</a-button> -->
            <!-- <a-button type="primary" icon="import" class="right-btn" >批量导入</a-button> -->
            <a-button type="primary" icon="plus" class="right-btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
        </div>
        <a-table 
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '150%' }"
            bordered>
            <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$refs.info.showDrawer('查看',text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <!-- <p class="table-tips">更新截至日期：{{lastTime}}</p> -->
        <info ref="info"></info>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/research/price'
    import Info from './modules/priceInfo'
    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:70,
            fixed: 'left',
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '获奖类别',
            dataIndex: 'winningType',
            align:'center',
            ellipsis: true,
        },
        {
            title: '获奖等级',
            dataIndex: 'winningGrade',
            align:'center',
            width:200,
        },
        {
            title: '获奖成果名称',
            dataIndex: 'winningName',
            align:'center',
            ellipsis: true,
        },
        {
            title: '证书编号',
            dataIndex: 'winningNo',
            align:'center'
        },
        {
            title: '完成人',
            dataIndex: 'winner',
            align:'center'
        },
        {
            title: '获奖时间',
            dataIndex: 'winningDate',
            align:'center',
            width:200,
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'id' },
            fixed: 'right',
            width:200,
        }

    ];
    export default {
        name: 'teacher',
        components: {
            Info
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    winningType:'',
                    winningGrade:'',
                    winningName:'',
                    winningNo:'',
                    winner:'',
                },
                hjdjArr:[],
                lastTime:'',
            }
        },
        mounted () {
            getDicts({dataCode:'KYCG-HJDJ',status:true}).then(res=>{
                this.hjdjArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            handSearch(value){
                if(value!=''){
                    this.searchFrom.consProjectTypeCode=value
                }
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除获奖成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

</style>
